<script lang="ts" setup>
import { inject, ref } from 'vue'
import type { ChapterConfig } from '../configs/types'
import { CHAPTER_LOCK, CHARGE_TYPE } from '@/constants'
import { useI18n } from '@/composables/useI18n'

interface Props {
  chapter: any
  showDownloadApp: boolean
  contentId: string
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'unlock-chapter'): void
  (e: 'call-app', contentId: string, sequenceNo: number): void
}>()

const config = inject<ChapterConfig>('chapterConfig')!
const autoLock = ref(true)
const { t } = useI18n()

function handleUnlock() {
  emit('unlock-chapter')
}

function handleCallApp() {
  emit('call-app', props.contentId, props.chapter.sequenceNo)
}

function toggleAutoLock() {
  autoLock.value = !autoLock.value
}

defineExpose({
  autoLock,
})
</script>

<template>
  <div v-if="chapter?.lockStatus === CHAPTER_LOCK.LOCK" class="pt-40px chapter-payment text-center">
    <h3 class="theme-h3 font-bold text-18px text-center text-#32353A">
      {{ config.texts.unlockTitle }}
    </h3>
    <p class="theme-desc mt-8px lh-24px text-14px text-#65686F text-center" style="white-space: pre-line;">
      {{ config.texts.unlockDesc }}
    </p>

    <!-- 解锁按钮 -->
    <a
      class="theme-btn inline-block mt-24px px-24px py-3 min-h-40px lh-1em text-15px text-white text-center bg-n-primary rounded-full w-300px"
      @click.stop="handleUnlock"
    >
      <span v-if="chapter.chargeType === CHARGE_TYPE.CHAPTER">{{ t('CoinsToRead2', { 0: chapter.priceAmount }) }}</span>
      <span v-else>{{ t('CoinsToReadBook', { 0: chapter.priceAmount }) }}</span>
    </a>

    <!-- 在 App 中继续阅读按钮 -->
    <a
      v-if="showDownloadApp"
      class="theme-sub-btn inline-block mt-12px px-24px lh-1em py-3 text-center min-h-40px text-15px text-white text-center rounded-full w-300px font-medium"
      @click="handleCallApp"
    >
      {{ config.texts.continueInApp }}
    </a>

    <!-- 自动解锁开关 -->
    <div class="theme-radio mt-10px flex justify-center items-center" @click.stop="toggleAutoLock">
      <div class="radio flex justify-center items-center w-14px h-14px inline-block border b-#9296A0 b-rd-14px cursor" :class="{ selected: autoLock }">
        <span class="inline-block w-6px h-6px bg-n-primary b-rd-6px" />
      </div>
      <span class="ml-6px label text-14px text-#65686F">{{ config.texts.autoUnlock }}</span>
    </div>

    <!-- Coins 余额 -->
    <p class="theme-balance mt-24px pb-18px lh-24px text-14px text-#9296A0 text-center">
      {{ t('NovelBalance', { 0: chapter.memberCoin }) }}
    </p>

    <!-- 渐变遮罩 -->
    <div class="mask" />
  </div>
</template>

<style lang="scss" scoped>
.radio {
  span {
    display: none;
  }
  &.selected {
    border-color: var(--primary-color);
    span {
      display: inline-block
    }
  }
}

.chapter-payment {
  position: relative;
  .mask {
    position: absolute;
    top: -126px;
    left: 0;
    width: 100%;
    height: 126px;
  }
}
</style>
